import en from "commonAssets/i18n/en";

export default { en };
